import { render, staticRenderFns } from "./RequestLoginForm.vue?vue&type=template&id=24b1505e&scoped=true&"
import script from "./RequestLoginForm.vue?vue&type=script&lang=js&"
export * from "./RequestLoginForm.vue?vue&type=script&lang=js&"
import style0 from "./RequestLoginForm.vue?vue&type=style&index=0&id=24b1505e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b1505e",
  null
  
)

export default component.exports